var _defs, _text, _path, _path2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIdasuLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 172 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: TAEBAEK-milkyway-KSCpc-EUC-H, 'TAEBAEK milkyway';\n        font-size: 30px;\n        letter-spacing: -.07em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #304865;\n      }\n\n      .cls-2 {\n        stroke-width: 0px;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(47.48 73.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "IDASU"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86,12.04c47.14,0,85.5,23.33,85.5,52s-38.36,52-85.5,52S.5,92.71.5,64.04,38.86,12.04,86,12.04m0-.5C38.5,11.54,0,35.04,0,64.04s38.5,52.5,86,52.5,86-23.51,86-52.5S133.5,11.54,86,11.54h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m53.16.04v.5c23.49,0,50.95,10.44,73.47,27.94,23.63,18.36,38.2,41.41,38.97,61.66.41,10.69-3.22,19.82-10.49,26.42-7.87,7.14-19.49,10.92-33.59,10.92-23.49,0-50.95-10.44-73.47-27.94C24.42,81.16,9.85,58.11,9.08,37.87c-.41-10.69,3.22-19.82,10.49-26.42C27.45,4.31,39.06.54,53.16.54V.04m0,0c-13.73,0-25.69,3.58-33.92,11.04C-2.63,30.92,10.13,70.69,47.74,99.92c23.46,18.23,51.03,28.04,73.78,28.04,13.73,0,25.69-3.58,33.92-11.04,21.87-19.84,9.11-59.61-28.51-88.84C103.48,9.86,75.9.04,53.16.04h0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.84,
    cy: 14.78,
    r: 3.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 161.09,
    cy: 109.51,
    r: 3.25
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdasuLogo);
export default __webpack_public_path__ + "static/media/idasu_logo.7a9137c6280ccf5173f9f66b22ce627f.svg";
export { ForwardRef as ReactComponent };